import React from 'react';
import { Layout } from '../../components/Layout';
import { FileJson } from 'lucide-react';

export function PatternFormatPage() {
  return (
    <Layout fullWidth>
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-8">
          <FileJson className="h-8 w-8 text-indigo-400" />
          <h1 className="text-3xl font-bold text-white">Pattern Format</h1>
        </div>

        <div className="prose prose-invert max-w-none">
          <div className="space-y-8">
            <section>
              <h2>Pattern Syntax</h2>
              <p>
                WordPress block patterns follow a specific syntax that combines HTML comments with JSON attributes.
              </p>
              <div className="bg-gray-800/50 rounded-lg p-4 mt-4">
                <pre className="text-sm">
                  <code>
                    {`<!-- wp:group {"backgroundColor":"base"} -->
<div class="wp-block-group has-base-background-color">
  <!-- wp:paragraph -->
  <p>Your content here</p>
  <!-- /wp:paragraph -->
</div>
<!-- /wp:group -->`}
                  </code>
                </pre>
              </div>
            </section>

            <section>
              <h2>Attributes Reference</h2>
              <p>
                Common attributes that can be applied to blocks:
              </p>
              <div className="grid grid-cols-2 gap-4 mt-4">
                <div className="bg-gray-800/50 rounded-lg p-4">
                  <h3 className="text-lg font-semibold mb-2">Layout Attributes</h3>
                  <ul className="list-disc list-inside">
                    <li>align</li>
                    <li>layout.type</li>
                    <li>layout.justifyContent</li>
                    <li>layout.orientation</li>
                  </ul>
                </div>
                <div className="bg-gray-800/50 rounded-lg p-4">
                  <h3 className="text-lg font-semibold mb-2">Style Attributes</h3>
                  <ul className="list-disc list-inside">
                    <li>backgroundColor</li>
                    <li>textColor</li>
                    <li>fontSize</li>
                    <li>className</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2>Validation</h2>
              <p>
                All patterns are validated to ensure they meet WordPress standards:
              </p>
              <ul>
                <li>Valid block types</li>
                <li>Correct attribute syntax</li>
                <li>Proper nesting structure</li>
                <li>Valid HTML markup</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
}